<div class="bulk-statement-dialog">
  <!-- Dialog header -->
  <div class="bulk-statement-dialog-header flex-between-center">
    <div class="flex-start-center">
      <div class="m-0 font-18 flex-column flex-center-start pl-4">
        <span class="font-18 font-bold"> Create Statements </span>
      </div>
      <!-- </ng-container> -->
    </div>

    <span class="d-flex">
      <span class="close-modal">
        <i class="fal fa-times font-20 font-gray" (click)="handleClose()"></i>
      </span>
    </span>
  </div>

  <!-- Dialog body -->
  <div class="bulk-statement-dialog-body">
    <!-- filter div -->
    <div class="ui-g-12">
      <div class="ui-g-7">
        <div class="d-flex">
          <div>
            <app-checkbox label="" [fontSize]="11" [isChecked]="moveInvoice" (appChange)="handlemoveInvoices($event)"> </app-checkbox>
          </div>
          <div class="pl-2">
            <div>
              <span class="font-14 font-600"> Move invoices from previous statements </span>
            </div>
            <div>
              <span class="font-10 font-400"> All outstanding invoices from previous statements will be automatically moved to this new statement. </span>
            </div>
          </div>
        </div>
      </div>
      <div class="ui-g-5">
        <div class="float-right">
          <app-report-filter
          [dateType]="dateType"
          heading=""
          [hasExport]="false"
          path="create-bulk-statement"
          [updateUrl]="false"
          [hasStatement]="false"
          [hasAccountStatement]="true"
          [options]="filterOptions" (filterChange)="filterChange($event)"></app-report-filter>
        </div>
      </div>
    </div>
    <!-- filter div end-->
    <!-- statement table list start-->
    <div class="bulk-statement-table p-3">
      <!-- <div class="ui-g-12"> -->
        <table class="table fake-header">
          <thead>
            <tr>
              <th colspan="6" class="new-statement-header">New statement</th>
              <th colspan="3" class="old-statement-header">
                <i class="fal fa-info-circle" tooltipPosition="left" [escape]="false" tooltipStyleClass="ticket-tooltip modifier bulk-payment" [pTooltip]="pinnedIconTooltip"></i> Invoices on previous
                statements
              </th>
            </tr>
            <tr class="fake-header-no-padding">
              <th class="type"></th>
              <th class="customer-name"></th>
              <th class="statement-name"></th>
              <th class="new-in-code"></th>
              <th class="new-total-amount"></th>
              <th class="new-balance"></th>
              <th class="old-invoices"></th>
              <th class="old-total-amount"></th>
              <th class="old-balance"></th>
            </tr>
          </thead>
        </table>
        <p-table
          class="statement-list"
          [tableStyle]="{ 'min-width': '50rem' }"
          #dt
          [columns]="columns"
          [value]="bulkStatementList"
          [lazy]="true"
          [scrollable]="true"
          [customSort]="true"
          [sortField]="'customerName'"
          [sortOrder]="1"
        >
          <ng-template pTemplate="header">
            <tr class="bulk-statement-grid-row-header border-0">
              <th class="bulk-statement-checkbox type new-statment-bg">
                <app-checkbox
                  inputId="bulkstatement-1"
                  [binary]="false"
                  [isChecked]="selectedItemsService.isPageSelected(this.currentPage)"
                  (appChange)="toggleSelectAll()"
                  [checkState]="tableCheckState"
                  [disabled]="isPageHasAllItemDisabled()"
                  [pTooltip]="isPageHasAllItemDisabled() ? 'All new invoices are 0' : 'Select all statements'"
                >
                </app-checkbox>
              </th>

              <th class="customer-name new-statment-bg">Customer name</th>

              <th class="statement-name new-statment-bg">Statement name</th>

              <th class="new-in-code new-statment-bg">Invoices (#)</th>

              <th class="new-total-amount new-statment-bg">Total amount</th>

              <th class="new-balance new-statment-bg">Outstanding balance</th>

              <th class="old-invoices old-statment-bg">Invoices (#)</th>

              <th class="old-total-amount old-statment-bg">Total amount</th>

              <th class="old-balance old-statment-bg">Outstanding balance</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr class="bulk-statement-grid-row">
              <td class="bulk-statement-checkbox type new-statment-bg">
                <p class="mb-0">
                  <app-checkbox
                    [isChecked]="selectedItemsService.isItemSelected(this.currentPage, rowData)"
                    [pTooltip]="rowData.newInvoiceCount == 0 && !moveInvoice ? 'New invoice count is 0' : 'Select statement'"
                    [disabled]="rowData.newInvoiceCount == 0 && !moveInvoice"
                    tooltipPosition="top"
                    [checkState]="tableCheckState"
                    (click)="toggleSelection(rowData)"
                  >
                  </app-checkbox>
                </p>
              </td>

              <td *ngFor="let col of columns" [ngClass]="col.className">

                <div *ngIf="!['name','statementName','newInvoiceCount','newTotal','newUnpaid'].includes(col.field)">
                  {{ rowData[col.field] }}
                </div>
                <div *ngIf="['newInvoiceCount','newTotal','newUnpaid'].includes(col.field)">
                  <span *ngIf="!moveInvoice">{{ rowData[col.field] }}</span>
                  <span *ngIf="moveInvoice">{{ rowData?.showMoveInvice[col.field]}}</span>
                </div>

                <div *ngIf="col.field === 'name'" (click)="rowData.newInvoiceCount == 0 && !moveInvoice ? $event.stopPropagation() : openStamentsDetails(rowData)">
                  <p class="mb-0 pointer text-truncate" [ngStyle]="{ color: selectedItemsService.isItemSelected(this.currentPage, rowData) ? 'var(--primary-500)' : '' }">
                    <span tooltipPosition="top" [pTooltip]="rowData[col.field]"> {{ rowData[col.field] }} </span>
                  </p>
                </div>

                <div
                  *ngIf="col.field === 'statementName'"
                  (click)="rowData.newInvoiceCount == 0 && !moveInvoice ? $event.stopPropagation() : openStamentsDetails(rowData)"
                >
                  <p class="mb-0 pointer text-truncate">
                    <span tooltipPosition="top" [pTooltip]="rowData[col.field]"> {{ rowData[col.field] }} </span>
                  </p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="ui-g-12 text-center not-found" *ngIf="loading && !bulkStatementList?.length">Loading...</div>

        <div *ngIf="!loading && !bulkStatementList?.length" class="ui-g-12 text-center not-found">
          <!-- <img src="assets/img/stock-list-empty.png" class="width-100" alt="" /> -->
          <span class="font-gray-35 font-12 mt-2">There are no statement list</span>
        </div>
      <!-- </div> -->
      <p-paginator class="ui-g-12 p-0" #pp [rows]="'8'" [totalRecords]="totalRecords" (onPageChange)="paginate($event)" [hidden]="totalRecords < 8"> </p-paginator>
    </div>
    <!-- statement table list end-->
  </div>

  <!-- Dialog footer -->
  <!-- <div></div> -->
  <div class="bulk-statement-dialog-footer">
    <div class="ui-g-12">
      <div class="flex-end-center">
        <button class="btn btn-primary btn-submit" [disabled]="isSubmittingGenerateAndSend" (click)="handleSubmit('isSubmittingGenerate')">
          Generate statements
          <i class="fal fa-spinner rotate ml-2" *ngIf="isSubmittingGenerate"></i>
        </button>

        <button class="btn btn-primary btn-submit ml-2" [disabled]="isSubmittingGenerate" (click)="handleSubmit('isSubmittingGenerateAndSend')">
          Generate and Send statements
          <i class="fal fa-spinner rotate ml-2" *ngIf="isSubmittingGenerateAndSend"></i>
        </button>
      </div>
    </div>

    <!-- <div class="flex-start">

    </div> -->
  </div>
</div>
